import PropTypes from 'prop-types';
import React from 'react';

import './seatPill.css';

const SeatPill = ({ children }) => (
  <span className="seat-pill">{children}</span>
);

SeatPill.propTypes = {
  children: PropTypes.node.isRequired,
};

export default SeatPill;
